import styled from 'styled-components';

const RealtySellingWrapper = styled.div`
.sidebar {
    height: fit-content;
    & .desc {
      font-size: 12px;
      text-align: right;
      letter-spacing: 0px;
      color: #000000;
      margin: 0;
    }
    & .ant-divider-horizontal {
      margin: 15px 0;
      border-top-color: #018b2b;
    }
  
    .steps {
      .step {
        align-items: baseline;
        i {
          font-size: 11px;
          font-weight: bold;
        }
        p {
          font-size: 13px;
        }
      }
    }
  }
  .form-inputs {
    input {
      font-size: 13px;
      height: 32px
    }
  }
  
  .p-radiobutton .p-radiobutton-box {
    border: 1px solid var(--main-color);
    margin: auto;
    border-radius: 10px;
    opacity: 1;
    width: 15px;
    height: 15px;
  
    .p-radiobutton-icon {
      display: none;
      visibility: hidden;
    }
    &.p-highlight {
      border-color: var(--main-color);
      background: var(--main-color);
    }
  }
  .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
    border-color: var(--main-color);
    background: var(--main-color);
  }
  .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
    border-color: var(--main-color);
  }
  .p-dropdown-label {
    padding: 3px;
  }
  
  .add-buyer {
    padding: 0;
    margin: 20px 0;
    background: transparent;
    color: var(--main-color);
    border: none;
    box-shadow: none;
    .p-button-icon {
      margin: 0;
      background: var(--main-color);
      color: white;
      padding: 4px;
      font-size: 13px;
      border-radius: 50%;
    }
    .p-button-label {
      margin: 0 5px;
    }
  
    &:hover {
      background: transparent;
      color: var(--main-color);
    }
  }
  .action-btn {
    border-radius: 10px;
    opacity: 1;
    border: none;
    color: white;
    justify-content: center;
    &.submit-btn {
      background: var(--main-color);
      color:white;
      &:disabled{
        background:#d2d2d2;
      }
    }
    &.back-btn {
      background: white;
      border: 1px solid var(--main-color);
      color: var(--main-color);
    }
  }
  .exit-btn {
    margin: auto auto 0 auto;
    width: fit-content;
    border: 1px solid #286c4d;
    border-radius: 10px;
    background: #e5ede9;
    color: #286c4d;
  }
  .realty-table {
    border-radius: 10px;
    font-size: 13px;
    background: #ffffff 0% 0% no-repeat padding-box;
    opacity: 1;
  
    .p-column-header-content {
      justify-content: center;
    }
  
    & td {
      text-align: center;
    }
    .p-checkbox .p-checkbox-box {
      border: 1px solid var(--main-color);
      margin: auto;
      border-radius: 3px;
      opacity: 1;
      width: 15px;
      height: 15px;
    }
  }
  .other-belongings {
    margin-top: 70px;
  }

  .addShare {
    border-radius: 0 5px 5px 0;
  }
  .numOfShares {
    border-radius: 5px 0 0 5px;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight{
    color: white !important;
  }
  .bHajzx .p-dropdown-label{
    font-style: 13px;
  }
  .buyerInfo{
    .p-input-icon-left>i {
      position: absolute;
      top: 50%;
      margin-top: -5px;
    }
  }
}

.dinar {
  border-radius: 7px 0 0 7px !important;
  width: 35% !important;
}
.dinar-value {
  border-radius: 0 7px 7px 0 !important;
}
`;

export default RealtySellingWrapper;